<template>
    <div class="ls-super-grid grid grid--justify-center">
        <div class="grid__col-xs-12 get-pricing__container">
            <div v-if="loading.quotingOrder">
                <ls-loading-bar-v1 v-if="loading.loadingType === 'progressBar'"></ls-loading-bar-v1>
                <ls-loading v-else></ls-loading>
            </div>
            <ls-get-quote-form v-else></ls-get-quote-form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import lsLoading from '@/components/original-mydot/loading/Loading.vue';
import lsLoadingBarV1 from '@/components/original-mydot/loading-bar-v1/LoadingBarV1.vue';
import lsGetQuoteForm from '@/components/original-mydot/get-quote-form/GetQuoteForm.vue';

import 'cleave.js/dist/addons/cleave-phone.us';

export default {
    components: {
        lsLoading,
        lsLoadingBarV1,
        lsGetQuoteForm,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['loading']),
    },
};
</script>

<style lang="scss" scoped>
.get-pricing__container {
    max-width: 630px;
}
</style>
